import React from 'react';
import PropTypes from 'prop-types';

import SrCard from 'client/components/SrCard/SrCard';
import SrText from 'client/components/SrText';
import SrBox from 'client/components/SrBox';

const SrUtilityRecentlyUnlistedAddresses = ({ onAddressClick, recentlyUnlistedAddresses = [] }) => {
  return (
    <SrCard width="100%" padding="16px" borderRadius="16px">
      <SrText weight="800" fontSize="16px" lineHeight="19px" font="greycliff">
        Recent Rentals
      </SrText>
      <SrBox marginTop="12px">
        {recentlyUnlistedAddresses.map((address) => (
          <SrBox
            key={address.id}
            marginTop="8px"
            padding="4px 0"
            cursor="pointer"
            onClick={() => onAddressClick({ address })}
          >
            <SrText
              fontSize="14px"
              lineHeight="16px"
              font="greycliff"
              color="blue300"
              weight="800"
              display="block"
              whiteSpace="nowrap"
              textOverflow="ellipsis"
              overflow="hidden"
            >
              {address.display}
            </SrText>
          </SrBox>
        ))}
        <SrBox marginTop="8px">
          <SrText fontSize="14px" lineHeight="16px" font="greycliff" color="grey" weight="600">
            Use the search above to find more...
          </SrText>
        </SrBox>
      </SrBox>
    </SrCard>
  );
};

SrUtilityRecentlyUnlistedAddresses.propTypes = {
  recentlyUnlistedAddresses: PropTypes.array,
  onAddressClick: PropTypes.func,
};

SrUtilityRecentlyUnlistedAddresses.displayName = 'SrUtilityRecentlyUnlistedAddresses';

export default SrUtilityRecentlyUnlistedAddresses;
